export var InteractionType;
(function (InteractionType) {
    InteractionType["NOTES"] = "NOTES";
    InteractionType["PROGRAM_EXPIRED"] = "PROGRAM_EXPIRED";
    InteractionType["MOOD"] = "MOOD";
})(InteractionType || (InteractionType = {}));
//# sourceMappingURL=interaction-type.enum.js.map